import type { Dayjs } from 'dayjs';

export enum BillingPolicyType {
    NO_SHOW = 'NO_SHOW',
    LATE_CANCELLATION = 'LATE_CANCELLATION',
    RESCHEDULE = 'RESCHEDULE',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
    FULL_SELF_PAYMENT = 'FULL_SELF_PAYMENT',
    CO_PAY = 'CO_PAY',
    OTHER = 'OTHER',
}

export interface BillingPolicy {
    type: BillingPolicyType;
    timeFrame: number;
    fee: number;
    id: number;
}

export interface IBillingPolicy extends BillingPolicy {
    enable: boolean;
}

export enum ConsentFormType {
    PAYMENT_CANCELLATION = 'PAYMENT_CANCELLATION',
    TREATMENT_CONSENT = 'TREATMENT_CONSENT',
    HIPAA_PRIVACY = 'HIPAA_PRIVACY',
}

export interface ConsentForm {
    type: ConsentFormType;
    content: string;
}

export enum AddressPublicType {
    PRIVATE = 'PRIVATE',
    INVITATION = 'INVITATION',
    WALK_IN = 'WALK_IN',
}

export interface Address {
    id?: number;
    practiceAddress: string;
    practiceCity: string;
    practiceState: string;
    practiceZip: string;
    publicType?: AddressPublicType;
    isDefault: boolean;
    asMailing: boolean;
}

export interface PracticeInfo {
    practiceDesc?: string;
    practiceEmail?: string;
    practiceLogo?: string;
    practiceName: string;
    practicePhone?: string;
    taxId?: string;
    taxIdType?: string;
    notHavePhone?: boolean;
}

export interface PracticeProfile extends PracticeInfo {
    addressList: Address[];
    firstName?: string;
    lastName?: string;
    id?: number;
    practiceDescConversationId?: string;
}

// 接口请求参数
export interface ApiPracticeProfile {
    step: 'PRACTICE';
    providerPractice: PracticeProfile;
}

export enum BusinessType {
    INDIVIDUAL = 'INDIVIDUAL',
    MULTIPLE_MEMBERS_LLC = 'MULTIPLE_MEMBERS_LLC',
    SINGLE_MEMBER_LLC = 'SINGLE_MEMBER_LLC',
    SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
    OTHERS = 'OTHERS',
}

export interface CompanyInfo {
    companyName: string;
    state: string;
    city: string;
    address: string;
    zip: string;
    taxId: string;
}

export enum RepresentativeAndPersonalInfoType {
    REPRESENTATIVE = 'REPRESENTATIVE',
    PERSONAL = 'PERSONAL',
}

export interface RepresentativeAndPersonalInfo {
    type: RepresentativeAndPersonalInfoType;
    firstName: string;
    middleName?: string;
    lastName: string;
    birthday: string | Dayjs;
    phoneNumber: string;
    email: string;
    state: string;
    city: string;
    address: string;
    zip: string;
    taxId: string;
    id?: number;
}

export interface BusinessInfo {
    businessType?: BusinessType;
    sameAsRepresentative?: boolean;
    companyInfoReq?: CompanyInfo;
    representativeAndPersonalInfoReqList?: RepresentativeAndPersonalInfo[];
}

export enum PayoutAccountType {
    CHECKING = 'CHECKING',
    TOZA = 'TOZA',
    SAVINGS = 'SAVINGS',
    FUTSU = 'FUTSU',
}

export interface PayoutAccount {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    bankName?: string;
    accountType?: PayoutAccountType | null;
    routingNumber?: string;
    accountNumber?: string;
    confirmAccountNumber?: string;
}
